<template>
  <div class="loading-mask" v-show="pageLoading">
    <div class="load">
      <em class="loading load1"></em>
      <em class="loading load2"></em>
      <em class="loading load3"></em>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useLoading from "@hooks/useLoading";
const { pageLoading } = useLoading();
</script>

<style lang="scss" scoped>
@import "@assets/scss/dimen.scss";
.loading-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1002;
  background-color: rgba(0, 0, 0, 0.6);
}
.load {
  position: fixed;
  left: 50%;
  top: 50%;
  font-size: 30px;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
  .loading {
    display: inline-block;
    margin: auto 2px;
    border: 2px solid $maincolor;
    width: 16px;
    height: 50px;
    background: $maincolor;
    animation: loading 1s infinite;
  }
  .load2 {
    animation-delay: 0.1s;
  }
  .load3 {
    animation-delay: 0.2s;
  }
}
@keyframes loading {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0.4;
    transform: scale(0.5);
  }
}
</style>
